import React, { Component } from "react";
import Slider from "react-slick";
import { slideSlick } from "../../page-demo/script";

const SlideList = [
    {
        textPosition: 'text-center',
        bgImage: 'bg_image--35',
        category: '',
        title: 'Logo Design',
        description: 'Our well-crafted logo not only increases the brands popularity it can also leave a lasting impact on your customers. We can bring the best outcomes for your business using perfect colors and design.',
        buttonText: 'Contact Us',
        buttonLink: '/contact'
    },
    {
        textPosition: 'text-center',
        bgImage: 'bg_image--34',
        category: '',
        title: 'E-Commmerce Solution',
        description: 'We have the expertise and resources to raise your business and guide you toward leadership with our comprehensive e-commerce solutions. Our offerings empower you to showcase and sell your products and services worldwide, facilitating seamless online transactions for a global audience.',
        buttonText: 'Contact Us',
        buttonLink: '/contact'
    },
    {
        textPosition: 'text-center',
        bgImage: 'bg_image--33',
        category: '',
        title: 'Web Development & Design',
        description: 'We deliver top-notch web development and design solutions tailored specifically to meet your business requirements. Our team of experts ensures a seamless process from initiation to completion, guaranteeing precision and excellence at every step.',
        buttonText: 'Contact Us',
        buttonLink: '/contact'
    }
]
class SliderOne extends Component {
  render() {
    return (
        <div className="slider-activation">
            <Slider className="rn-slick-dot dot-light" {...slideSlick}>
                {SlideList.map((value , index) => (
                    <div className={`slide slide-style-2 fullscreen d-flex align-items-center justify-content-center bg_image ${value.bgImage}`} key={index} data-black-overlay="8">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className={`inner ${value.textPosition}`}>
                                        {value.category ? <span>{value.category}</span> : ''}
                                        {value.title ? <h1 className="title theme-gradient">{value.title}</h1> : ''}
                                        {value.description ? <p className="description">{value.description}</p> : ''}
                                        {value.buttonText ? <div className="slide-btn"><a className="rn-button-style--2 btn-primary-color" href={`${value.buttonLink}`}>{value.buttonText}</a></div> : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
  }
}
export default SliderOne;